import { c as _c } from "react/compiler-runtime";
import { GoogleButton } from '@onefootprint/ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import getAuthRedirectUrl from '../../get-auth-redirect-url';
import useResetOnPageRestore from '../use-reset-on-page-restore';
const SocialButtons = () => {
  const $ = _c(8);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "socialButtons"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("authentication", t0);
  const [loading, setLoading] = useState(false);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setLoading(false);
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  useResetOnPageRestore(t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setLoading(true);
      window.location.href = `${process.env.NEXT_PUBLIC_API_BASE_URL}/org/auth/google_oauth?redirect_url=${getAuthRedirectUrl()}`;
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleClick = t2;
  let t3;
  if ($[3] !== t) {
    t3 = t(_temp);
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== loading || $[6] !== t3) {
    t4 = <GoogleButton size="large" fullWidth={true} onClick={handleClick} loading={loading}>{t3}</GoogleButton>;
    $[5] = loading;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};
export default SocialButtons;
function _temp($) {
  return $.google;
}